import { BUSCAR_ITINERARIOS_ABERTOS_VENDA_URBANA } from '../../actions/types'

const initial = []

export default function reducerItinerariosAbertosVendaUrbana (state = initial, action = {}) {
  switch (action.type) {
    case BUSCAR_ITINERARIOS_ABERTOS_VENDA_URBANA: {
      return action.payload || []
    }

    default:
      return state
  }
}
